import { AdStepProgress, StepsProgresses } from '@/models/propertyProgress.model';
import { StepType } from '@/models/step.model';
import { showApiErrors } from '@/utils';
import { createSlice, isPending, isRejected } from '@reduxjs/toolkit';
import { getPropertyProgress, resetPropertyStep, stopPropertyAd } from './actionCreators';
import { initialState, PROPERTY_PROGRESS_SLICE_NAME, PropertyProgressState } from './models';

export const slice = createSlice({
  name: PROPERTY_PROGRESS_SLICE_NAME,
  initialState,
  reducers: {
    resetState: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(getPropertyProgress.fulfilled, (state: PropertyProgressState, action) => {
        const { payload } = action;
        state.isLoading = false;
        state.error = null;
        state.propertyOwner = payload.property_owner;
        state.totalOrdersSum = payload.total_orders_sum;
        state.progress = payload.progress;
        state.stepsProgresses = payload.steps.reduce((acc, item) => {
          acc[item.step_name] = item;
          return acc;
        }, {} as Record<StepType, StepsProgresses>);
      })
      .addCase(resetPropertyStep.fulfilled, (state: PropertyProgressState, action) => {
        const { payload } = action;
        state.isLoading = false;
        state.error = null;
        state.stepsProgresses = {
          ...(state.stepsProgresses ?? {}),
          [payload.step_name]: payload,
        };
      })
      .addCase(stopPropertyAd.fulfilled, (state: PropertyProgressState, action) => {
        const { payload } = action;
        state.isLoading = false;
        state.error = null;
        state.stepsProgresses = {
          ...(state.stepsProgresses ?? {}),
          [StepType.AD]: {
            ...state?.stepsProgresses?.[StepType.AD],
            advertisement: payload,
          } as AdStepProgress,
        };
      })
      .addMatcher(isPending(getPropertyProgress, resetPropertyStep), (state: PropertyProgressState) => {
        state.isLoading = true;
        state.error = null;
      })
      .addMatcher(isRejected(getPropertyProgress, resetPropertyStep), (state: PropertyProgressState, action) => {
        const { error } = action;
        state.isLoading = false;
        state.error = error;

        showApiErrors(error);
      });
  },
});

export default slice.reducer;

export const { resetState } = slice.actions;
